// TEMP CORE-9199 remove after Oct 30
import { useEffect, useState } from 'react'
import { fetchShadowSession } from './shadowSession.actions'
import type { ShadowSessionResponse } from './shadowSession.types'

const POLL_MS = 10_000

export const useShadowSession = (userId: number) => {
  const [data, setData] = useState<ShadowSessionResponse | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    let timer: ReturnType<typeof setTimeout> | undefined

    const tick = async () => {
      if (!document.hidden) {
        try {
          const next = await fetchShadowSession(userId)
          if (!cancelled) {
            setData(next)
            setError(null)
          }
        } catch (err) {
          if (!cancelled)
            setError(err instanceof Error ? err.message : 'Request failed')
        }
      }
      if (!cancelled) timer = setTimeout(tick, POLL_MS)
    }

    void tick()
    return () => {
      cancelled = true
      clearTimeout(timer)
    }
  }, [userId])

  return { data, error }
}
